import React, { useState, useRef, useEffect } from 'react';
import * as PopoverComponent from '@radix-ui/react-popover';
import css from './Popover.module.css';
import classNames from 'classnames';

const Popover = ({
  children,
  contentComponent,
  contentClassName,
  contentAlign,
  triggerClassName,
  open,
  onOpenChange,
}) => {
  return (
    <PopoverComponent.Root open={open} onOpenChange={onOpenChange}>
      <PopoverComponent.Trigger className={classNames(css.trigger, triggerClassName)}>
        {children}
      </PopoverComponent.Trigger>
      <PopoverComponent.Portal>
        <PopoverComponent.Content
          className={classNames(css.popoverContent, contentClassName)}
          align={contentAlign}
        >
          {contentComponent}
          <PopoverComponent.Arrow className={css.popoverArrow} />
        </PopoverComponent.Content>
      </PopoverComponent.Portal>
    </PopoverComponent.Root>
  );
};

export default Popover;
